import React, { Component } from 'react';
import { Tooltip } from 'react-tippy';
import { Cookies } from 'react-cookie';
import 'react-tippy/dist/tippy.css';
import {Element, scroller} from 'react-scroll';
import {Helmet} from 'react-helmet';

import _ from 'lodash';

import LearnMore from '../../components/Forms/LearnMore';
import ReasonsResults from '../../components/Reasons/ReasonsResults';
import iconChecks from '../../assets/svg/icon-checks.svg';
import ScrollButton from '../../components/Header/ScrollButton';
import * as ResultHelpers from '../../helpers/results';
import {encodeUrl} from '../../helpers/quiz';
import * as RouteHelpers from '../../helpers/routes';

class ResultsBiz extends Component {
  state = {
    plans: [],
    selectedPlan: [],
    loading: true,
    url: `${process.env.REACT_APP_API_URL}/plans/group`,
    formResults: _.clone(this.props.fieldValues),
    FamilyType: 'Individual',
    FamilyTypePlural: 'Individuals',
    showModal: false,
    open: false,
    animateChangePrice: false,
    trackOnce: true
  };

  componentDidMount () {
    const p = _.clone(this.props);
    const cookies = new Cookies();

    if (cookies.get('CDPHP_myResults') && this.props.showResults) { // Check for cookie
      this.setState({ formResults: cookies.get('CDPHP_myResults') });
    }

    if (p.route !== 'quote') {
      const fieldValues = _.merge({}, p.quiz.fieldValues, {'ResultsType': 'ResultsBiz'});
      const resultString = encodeUrl(fieldValues);
      cookies.set('CDPHP_quoteString', resultString, { path: '/' });
      RouteHelpers.history.push('/quote/' + resultString);
    } else if (Object.keys(p.rest.quote).length === 0) {
      p.reducer({fieldValues: p.quiz.fieldValues, url: 'group'});
      p.updateHeaderPhone('866-242-8830');
      p.toggleInQuiz(false);
      p.toggleInResults(true);
      p.updateResultsFooter(true, {
        'jdpower': 'true'
      });
      p.updateResultsRatings(true, {
        'jdpower': 'true'
      });
      p.updateHeaderScroller(
        <ScrollButton
          text='Contact Me'
          scrollName='learnForm'
          scrollOpts={{
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -200
          }}
        />
      );
    }
  }

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {quiz, rest} = p;
    const {fieldValues} = quiz;

    if (_.isObject(rest.quote) && Object.keys(rest.quote).length) {
      // set state once we have data from the server on the selected plan:
      const pOP = _.clone(rest.quote.planOrderPremium);
      const pOM = _.clone(rest.quote.planOrderMax);

      const newPremiumOrder = pOP.sort((a, b) => (
        a.IndividualPremium < b.IndividualPremium ? -1 :
          a.IndividualPremium > b.IndividualPremium ? 1 : 0
      ));

      const newMaxOrder = pOM.sort((a, b) => (
        a.IndividualOopMax < b.IndividualOopMax ? -1 :
          a.IndividualOopMax > b.IndividualOopMax ? 1 : 0
      ));

      const result = rest.quote.selectedPlan;
      const planOrderPremium = newPremiumOrder;
      const planOrderDeductible = rest.quote.planOrderDeductible;
      const planOrderMax = newMaxOrder;
      let {lastSelectedPlanId} = _.clone(state);

      let monthlyPremium = null;
      let annualDeductible = null;
      let oopmax = null;
      let lowestPremium = null;
      let highestPremium = null;
      let lowestDeductible = null;
      let highestDeductible = null;
      let lowestMax = null;
      let highestMax = null;
      let monthlyDollars = '';
      let monthlyCents = '';
      let deductible;
      let deductibleAmount;
      let copayFirst = null;
      let copayFirstAmount;
      let oopMaxAmount;

      if (planOrderPremium) {
        switch (state.FamilyType) {
          case 'Individual' :
            monthlyPremium = result.IndividualPremium;
            annualDeductible = result.IndividualDeductible;
            copayFirst = (result.IsCopayFirst) ? result.IndividualCopayFirstCap : result.IndividualDeductible;
            oopmax = result.IndividualOopMax;
            lowestPremium = planOrderPremium[0].IndividualPremium;
            highestPremium = planOrderPremium[planOrderPremium.length - 1].IndividualPremium;
            lowestDeductible = planOrderDeductible[0].IndividualDeductible;
            highestDeductible = planOrderDeductible[planOrderDeductible.length - 1].IndividualDeductible;
            lowestMax = planOrderMax[0].IndividualOopMax;
            highestMax = planOrderMax[planOrderMax.length - 1].IndividualOopMax;
            break;

          case 'Family' :
            monthlyPremium = result.FamilyPremium;
            annualDeductible = result.FamilyDeductible;
            copayFirst = (result.IsCopayFirst) ? result.FamilyCopayFirstCap : result.FamilyDeductible;
            oopmax = result.FamilyOopMax;
            lowestPremium = planOrderPremium[0].FamilyPremium;
            highestPremium = planOrderPremium[planOrderPremium.length - 1].FamilyPremium;
            lowestDeductible = planOrderDeductible[0].FamilyDeductible;
            highestDeductible = planOrderDeductible[planOrderDeductible.length - 1].FamilyDeductible;
            lowestMax = planOrderMax[0].FamilyOopMax;
            highestMax = planOrderMax[planOrderMax.length - 1].FamilyOopMax;
            break;

          default :
            monthlyPremium = result.IndividualPremium;
            annualDeductible = result.IndividualDeductible;
            oopmax = result.IndividualOopMax;
            break;
        }
      }

      // Monthly Premiums, split whole amount and decimals for display
      if (monthlyPremium) {
        const monthlyPremiumString = monthlyPremium.toFixed(2).toString();
        monthlyDollars = monthlyPremiumString.slice(0, -3);
        monthlyCents = monthlyPremiumString.slice(-3);
      }

      deductible = result.HasDeductible;
      deductibleAmount = annualDeductible ? ResultHelpers.numberWithCommas(annualDeductible) : '0';
      copayFirstAmount = copayFirst ? ResultHelpers.numberWithCommas(copayFirst) : '0';
      oopMaxAmount = oopmax ? ResultHelpers.numberWithCommas(oopmax) : '';
      lowestPremium = lowestPremium ? ResultHelpers.numberWithCommas(Math.round(lowestPremium)) : '';
      highestPremium = highestPremium ? ResultHelpers.numberWithCommas(Math.round(highestPremium)) : '';
      lowestDeductible = lowestDeductible ? ResultHelpers.numberWithCommas(lowestDeductible) : '0';
      highestDeductible = highestDeductible ? ResultHelpers.numberWithCommas(highestDeductible) : '';
      lowestMax = lowestMax ? ResultHelpers.numberWithCommas(lowestMax) : '0';
      highestMax = highestMax ? ResultHelpers.numberWithCommas(highestMax) : '';

      if (lastSelectedPlanId !== rest.quote.SelectedPlanId) {
        if (state.trackOnce === true) {
          ResultHelpers.sendAnalyticsOnQuote(fieldValues, rest);
        }

        const headerPremium = (
          <h5 key={monthlyDollars + monthlyCents} className={'price'}>
            <strong key={monthlyDollars + monthlyCents}>
              ${ResultHelpers.numberWithCommas(monthlyDollars)}<sup
              >{monthlyCents}</sup></strong> /Month</h5>
        );
        lastSelectedPlanId = rest.quote.SelectedPlanId;
        props.updateHeaderPremium(headerPremium);
      }

      const newState = {
        lastSelectedPlanId,
        plans: rest.quote.Plans,
        selectedPlan: rest.quote.selectedPlan,
        selectedPlanID: rest.quote.SelectedPlanId,
        loading: false,
        fieldValues,
        planOrderPremium: newPremiumOrder,
        planOrderDeductible: rest.quote.planOrderDeductible,
        planOrderMax: newMaxOrder,
        monthlyPremium,
        annualDeductible,
        oopmax,
        lowestPremium,
        highestPremium,
        lowestDeductible,
        highestDeductible,
        lowestMax,
        highestMax,
        monthlyDollars,
        monthlyCents,
        deductible,
        deductibleAmount,
        copayFirstAmount,
        oopMaxAmount,
        trackOnce: false
      };

      return newState;
    }

    return null; // if no state mutations are required at this time
  }

  changePlan = (planOrder, direction, type, e) => {
    const plans = _.clone(planOrder);
    const currentPlanId = this.state.selectedPlanID;
    const currentPlan = plans.find((obj) => (obj.PlanId === currentPlanId));
    let i = plans.indexOf(currentPlan);
    let nextPlan = null;
    let limit = null;
    let direc = null;

    if (direction === 'inc') {
      nextPlan = plans[i + 1];
      limit = (i === (plans.length - 1));
      direc = 'Increase';
    } else {
      nextPlan = plans[i - 1];
      limit = (i === 0);
      direc = 'Decrease';
    }

    if (!limit) {
      // console.log('CHANGE');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'GAEvent',
        'eventCategory': 'Change',
        'eventAction': 'Results',
        'eventLabel': direc + ' ' + type,
        'eventValue': undefined
      });

      this.setState({
        animateChangePrice: true
      });

      setTimeout(
        function () {
          this.props.changeSelectedPlan(nextPlan);
          this.setState({
            animateChangePrice: false
          });
        }.bind(this), 750
      );
    }
  };

  changeFamilyType = (selectType) => {
    let plural;
    if (selectType === 'Individual') {
      plural = 'Individuals';
    } else if (selectType === 'Family') {
      plural = 'Families';
    }
    this.setState({
      animateChangePrice: true
    });
    setTimeout(
      function () {
        this.setState({
          FamilyType: selectType,
          FamilyTypePlural: plural,
          animateChangePrice: false
        });
        const {selectedPlan} = this.state;
        this.props.changeSelectedPlan({});
        this.props.changeSelectedPlan(selectedPlan);
      }.bind(this), 750
    );
  }

  setIsOpen = (option) => {
    this.setState({
      open: option
    });
  };

  static scrollTo () {
    scroller.scrollTo('learnForm', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -200
    });
  }

  render () {
    const s = _.clone(this.state);
    const result = s.selectedPlan;
    const {
      lowestPremium,
      highestPremium,
      lowestDeductible,
      highestDeductible,
      lowestMax,
      highestMax,
      FamilyType,
      FamilyTypePlural,
      monthlyDollars,
      monthlyCents,
      copayFirstAmount,
      deductible,
      deductibleAmount,
      oopMaxAmount
    } = s;

    let loading;
    if (s.loading) {
      loading = 'loading';
    }

    let discount = 'CDPHP Discounted Price';
    const discountContent = (<span>
      <p>CDPHP has negotiated reduced rates for most doctor and hospital visits to save you money. For example:</p>
      <ul>
        <li>
          <strong>MRI</strong><br />
          <span>Without insurance: <strong>$4,500</strong></span><br />
          <span className='green'>With CDPHP: <strong>$738</strong></span>
        </li>
        <li>
          <strong>Fractured Ankle</strong><br />
          <span>Without insurance: <strong>$7,800</strong></span><br />
          <span className='green'>With CDPHP: <strong>$2,869</strong></span>
        </li>
      </ul>
    </span>);

    const discountToolTip = <Tooltip html={discountContent} arrow='true' unmountHTMLWhenHide='true'>the <strong className='helpTip'>CDPHP Discounted&nbsp;Price</strong></Tooltip>;

    const dropDownMenu = (<ul className={'dropdownmenu ' + FamilyType}>
      <li><a className='individual-link' onClick={() => { this.changeFamilyType('Individual'); this.setIsOpen(false); }}>Individual</a></li>
      <li><a className='family-link' onClick={() => { this.changeFamilyType('Family'); this.setIsOpen(false); }}>Family</a></li>
    </ul>);
    const dropDownMenuPlural = (<ul className={'dropdownmenu ' + FamilyType}>
      <li><a className='individual-link' onClick={() => { this.changeFamilyType('Individual'); this.setIsOpen(false); }}>Individuals</a></li>
      <li><a className='family-link' onClick={() => { this.changeFamilyType('Family'); this.setIsOpen(false); }}>Families</a></li>
    </ul>);

    const selectTypeDropDown = <Tooltip html={dropDownMenu} open={s.open} onRequestClose={() => { this.setIsOpen(false); }}
      interactive='true' trigger='click' position='bottom'
      unmountHTMLWhenHide='true' size='small' arrow='true'><span className='dropdown' onClick={() => { this.setIsOpen(true); }}>{FamilyType}</span></Tooltip>;
    const selectTypeDropDownPlural = <Tooltip html={dropDownMenuPlural} open={s.open} onRequestClose={() => { this.setIsOpen(false); }}
      interactive='true' trigger='click' position='bottom'
      unmountHTMLWhenHide='true' size='small' arrow='true'><span className='dropdown' onClick={() => { this.setIsOpen(true); }}>{FamilyTypePlural}</span></Tooltip>;

    const cookies = new Cookies();
    let Loc = this.props.location;
    if (cookies.get('CDPHP_myResults')) {
      Loc = cookies.get('CDPHP_myResults').Location;
    }

    const animatePrice = s.animateChangePrice ? 'animatePrice active' : 'animatePrice';

    let mobileBefore = deductible ? <p className='mobile'>Before <span>${copayFirstAmount} in Expenses</span></p> : '';
    let mobileAfter = deductible ? <p className='mobile'>After <span>${copayFirstAmount} in Expenses</span></p> : <p className='mobile'>You Pay This Portion</p>;

    if (loading) {
      return <div className={'dark ' + loading} />;
    }

    const lowerPremiumDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderPremium) ||
      (s.selectedPlan.PlanId === s.planOrderPremium[0].PlanId);
    const higherPremiumDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderPremium) ||
      (s.selectedPlan.PlanId === s.planOrderPremium[s.planOrderPremium.length - 1].PlanId);

    const lowerMaxDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderMax) ||
      (s.selectedPlan.PlanId === s.planOrderMax[0].PlanId);
    const higherMaxDisabled = _.isUndefined(s.selectedPlan) || _.isUndefined(s.planOrderMax) ||
      (s.selectedPlan.PlanId === s.planOrderMax[s.planOrderMax.length - 1].PlanId);

    const lowerDeductibleDisabled = _.isUndefined(s.planOrderDeductible) || _.isUndefined(s.planOrderDeductible) ||
      (s.selectedPlan.PlanId === s.planOrderDeductible[0].PlanId);
    const higherDeductibleDisabled = _.isUndefined(s.planOrderDeductible) || _.isUndefined(s.planOrderDeductible) ||
      (s.selectedPlan.PlanId === s.planOrderDeductible[s.planOrderDeductible.length - 1].PlanId);

    return (
      <div className={'business dark ' + loading}>
        <Helmet>
          <title>Your CDPHP Plan Quote</title>
        </Helmet>

        <section id='intro' className='pb60'>
          <div className='wrap'>
            <h1>We have just the plan for your&nbsp;business.</h1>
            <h3><strong>{result.PlanName}</strong> for you and your&nbsp;employees.</h3>
          </div>
        </section>

        <section className=''>
          <div className='wrap sm'>
            <div className='container'>
              <img src={iconChecks} className='checks' alt='' />
              <ul className={'bullets ' + animatePrice}>
                <li>{result.PlanDescriptor1}</li>
                <li>{result.PlanDescriptor2}</li>
                <li>{result.PlanDescriptor3}</li>
              </ul>
              <div className='navigate'>
                <h3 className={animatePrice}>The
                  <Tooltip
                    title='This is your “Premium.” It’s the price you and your employees pay for ongoing insurance coverage.'
                    arrow='true'> <span className='helpTip'>monthly fee</span>
                  </Tooltip><br /> for {selectTypeDropDownPlural} is
                  <strong> ${ResultHelpers.numberWithCommas(monthlyDollars)}<sup>{monthlyCents}</sup></strong></h3>
                <nav>
                  <a
                    onClick={() => this.changePlan(s.planOrderPremium, 'dec', 'Premium')}
                    className={'lower ' + (lowerPremiumDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>–</strong
                    ><span>Options as low<br /> as ${lowestPremium}</span>
                  </a>

                  <a
                    onClick={() => this.changePlan(s.planOrderPremium, 'inc', 'Premium')}
                    className={
                      'higher ' + (higherPremiumDisabled ? 'disabled' : '')
                    }
                  ><strong className='btn alt'>+</strong><span>Options as high<br /> as ${highestPremium}</span>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </section>

        <ReasonsResults divide='' type='biz' />

        <section>
          <div className='wrap sm'>
            <div className='container'>
              <div className='navigate expenses'>
                <div className={animatePrice}>
                  <h4>{selectTypeDropDownPlural} are responsible for <Tooltip title='This is your “Deductible” It’s the amount you and your employees are required to pay out of pocket toward medical care each year before the plan begins to pay.' arrow='true'><span className='helpTip'><strong>${deductibleAmount}</strong> in medical expenses</span></Tooltip> before the plan helps them pay, plus a portion of the bills after that.</h4>
                </div>
                <nav>
                  <a
                    onClick={() => this.changePlan(s.planOrderDeductible, 'dec', 'Deductible')}
                    className={'lower ' + (lowerDeductibleDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>–</strong><span>Options as low<br /> as ${lowestDeductible}</span>
                  </a>

                  <a
                    onClick={() => this.changePlan(s.planOrderDeductible, 'inc', 'Deductible')}
                    className={'higher ' + (higherDeductibleDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>+</strong><span>Options as high<br /> as ${highestDeductible}</span>
                  </a>
                </nav>

                {deductible ?
                  <p className='info text-center'>Feel too pricey? You can reduce this cost, but the monthly payment will increase.</p> :
                  <p className='info text-center'>Willing to pay more? You can increase this cost to reduce the monthly payment.</p>
                }
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className='wrap sm'>
            <div className='results container'>
              <div className='table'>
                <table className={deductible ? '' : 'noDeductible'}>
                  <thead>
                    <tr className='heading'>
                      <th className='item'><h4>Plan Benefits</h4></th>
                      <th className='before'>{deductible ? <h4>Before <span>${copayFirstAmount} in Expenses</span></h4> : '' }</th>
                      <th className='after'>{deductible ? <h4>After <span>${copayFirstAmount} in Expenses</span></h4> : <h4>You Pay This Portion</h4> }</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr className='alt'>
                      <td className='item'
                      ><Tooltip interactive='true' html={(<span>With Enhanced Primary Care, the entire practice functions as your medical home – a place where doctors, nurse practitioners, and administrative staff provide the support you need to stay healthy. That means more one-on-one time with your doctor, better coordination of care, and higher-quality health outcomes. <a href='https://findadoc.cdphp.com' target='_blank' rel='noopener noreferrer'>Search for a participating enhanced primary care provider in your area</a>.</span>)} arrow='true'><h5 className='helpTip nowrap'>Enhanced Primary Care Visits</h5></Tooltip></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.EnhancedPrimaryCareVisitsPreDeductible === discount ? discountToolTip : (<strong>{result.EnhancedPrimaryCareVisitsPreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.EnhancedPrimaryCareVisitsPostDeductible}</strong></td>
                    </tr>
                    <tr>
                      <td className='item'><h5>Primary Care Visits</h5></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.PcpVisitPreDeductible === discount ? discountToolTip : (<strong>{result.PcpVisitPreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.PcpVisitPostDeductible}</strong></td>
                    </tr>
                    <tr className='alt'>
                      <td className='item'><h5>Specialist Doctor Visits</h5></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.SpecialistVisitPreDeductible === discount ? discountToolTip : (<strong>{result.SpecialistVisitPreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.SpecialistVisitPostDeductible}</strong></td>
                    </tr>
                    <tr>
                      <td className='item'><h5>Hospital Stays</h5></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.InpatientHospitalStaysPreDeductible === discount ? discountToolTip : (<strong>{result.InpatientHospitalStaysPreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.InpatientHospitalStaysPostDeductible}</strong></td>
                    </tr>
                    <tr className='alt'>
                      <td className='item'><h5>Surgery</h5></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.SurgeryPreDeductible === discount ? discountToolTip : (<strong>{result.SurgeryPreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.SurgeryPostDeductible}</strong></td>
                    </tr>
                    <tr>
                      <td className='item'><h5>Urgent Care</h5></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.UrgentCarePreDeductible === discount ? discountToolTip : (<strong>{result.UrgentCarePreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.UrgentCarePostDeductible}</strong></td>
                    </tr>
                    <tr className='alt'>
                      <td className='item'><h5>Emergency Room</h5></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.EmergencyRoomPreDeductible === discount ? discountToolTip : (<strong>{result.EmergencyRoomPreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.EmergencyRoomPostDeductible}</strong></td>
                    </tr>
                    <tr>
                      <td className='item'><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><h5 className='helpTip'>Prescription Drugs</h5></Tooltip></td>
                      <td className='before'>{mobileBefore}{deductible ? <span>Employees pay {result.PrescriptionsPreDeductible === discount ? discountToolTip : (<strong>{result.PrescriptionsPreDeductible}</strong>)}</span> : '' }</td>
                      <td className='after'>{mobileAfter}Employees pay <strong>{result.PrescriptionsPostDeductible}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className='navigate'>
                <div className={animatePrice}>
                  <h4>That&rsquo;s it! Once each {selectTypeDropDown} has paid a total of <Tooltip title='This is their “Out of Pocket Maximum.” It’s the most they’ll have to pay for covered health services in a plan year.' arrow='true'><span className='helpTip'><strong className='price'>${oopMaxAmount}</strong> toward their bills</span></Tooltip>, CDPHP covers everything through the end of the&nbsp;year.</h4>
                </div>

                <nav>
                  <a
                    onClick={() => this.changePlan(s.planOrderMax, 'dec', 'OOP Max')}
                    className={'lower ' + (lowerMaxDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>–</strong><span>Options as low<br /> as ${lowestMax}</span>
                  </a>
                  <a
                    onClick={() => this.changePlan(s.planOrderMax, 'inc', 'OOP Max')}
                    className={'higher ' + (higherMaxDisabled ? 'disabled' : '')}
                  ><strong className='btn alt'>+</strong><span>Options as high<br /> as ${highestMax}</span>
                  </a>
                </nav>
                <p className='info text-center'>Even in the event of a serious medical issue, they’ll never pay more than this in<br /> a plan year—as long as they see the doctors and hospitals in our plan.</p>
              </div>
            </div>
          </div>
        </section>

        <Element name='learnForm'>
          <LearnMore
            planName={result.PlanName}
            type='biz'
            area='EmployerQuote'
            closeModal={this.closeModalHandler}
            show={s.showModal}
            details={s.fieldValues}
            lastPlanId={result.PlanId}
            Location={Loc}
            phone='866-242-8830' />
        </Element>

        <section className='contact'>
          <div className='wrap sm text-center'>
            <h5>We’re here to help.</h5>
            <p>Call us at <a href='tel:866-242-8830' className='tel phoneswap'>866-242-8830</a>.</p>
          </div>
        </section>
      </div>
    );
  }
}

export default ResultsBiz;
